'use client';

import { useState, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { motion, AnimatePresence } from 'framer-motion';
import { CookieSettings } from './CookieSettings';

export function CookieBanner() {
  const [cookies, setCookie] = useCookies<any>(['cookieConsent', 'cookiePreferences']);
  const [isVisible, setIsVisible] = useState(false);
  const [isSettingsOpen, setIsSettingsOpen] = useState(false);

  useEffect(() => {
    // Show banner if consent hasn't been given yet
    if (cookies.cookieConsent === undefined) {
      setIsVisible(true);
    }
  }, [cookies.cookieConsent]);

  const acceptAll = () => {
    setCookie('cookieConsent', 'all', { path: '/', maxAge: 60 * 60 * 24 * 365 }); // 1 year
    setCookie('cookiePreferences', {
      necessary: true,
      functional: true,
      analytics: true,
      marketing: true
    }, { path: '/', maxAge: 60 * 60 * 24 * 365 });
    setIsVisible(false);
  };

  const acceptNecessary = () => {
    setCookie('cookieConsent', 'necessary', { path: '/', maxAge: 60 * 60 * 24 * 365 }); // 1 year
    setCookie('cookiePreferences', {
      necessary: true,
      functional: false,
      analytics: false,
      marketing: false
    }, { path: '/', maxAge: 60 * 60 * 24 * 365 });
    setIsVisible(false);
  };

  const openSettings = () => {
    setIsSettingsOpen(true);
  };

  const closeSettings = () => {
    setIsSettingsOpen(false);
  };

  return (
    <>
      <AnimatePresence>
        {isVisible && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-[#1A1A1D] text-white border-t border-neutral-700 shadow-xl"
          >
            <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="flex-1">
                <h3 className="font-semibold text-lg text-white">Cookie Preferences</h3>
                <p className="text-sm text-gray-300 mt-1">
                  We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.
                </p>
              </div>
              <div className="flex flex-wrap gap-3">
                <button
                  onClick={openSettings}
                  className="px-4 py-2 text-sm border border-neutral-600 text-white rounded-md hover:bg-neutral-800 transition"
                >
                  Customize
                </button>
                <button
                  onClick={acceptNecessary}
                  className="px-4 py-2 text-sm border border-neutral-600 text-white rounded-md hover:bg-neutral-800 transition"
                >
                  Necessary Only
                </button>
                <button
                  onClick={acceptAll}
                  className="px-4 py-2 text-sm bg-[#F1EFEC] text-[#1A1A1D] font-medium rounded-md hover:opacity-90 transition"
                >
                  Accept All
                </button>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      
      <CookieSettings isOpen={isSettingsOpen} onClose={closeSettings} />
    </>
  );
} 